// The full Basis of Unit Price Code list (DE 639) — shared by PO1's and
// CTP's basis-of-unit-price positions across transaction sets. It is the
// union of the previous hand-picked PO1 position-5 subset
// (item-loop-segments.ts) and the 855-specific PO104/CTP-basis list in
// reference/session/855-purchase-order-acknowledgment-qualifiers-txt.md, and
// is the canonical list going forward.

import type {CodeListEntry} from './types';

export const BASIS_OF_UNIT_PRICE_CODES: CodeListEntry[] = [
  {code: 'PE', label: 'Price per Each'},
  {code: 'UM', label: 'Price per Unit of Measure'},
  {code: 'HP', label: 'Price per Hundred'},
  {code: 'TP', label: 'Price per Thousand'},
  {code: 'CT', label: 'Contract'},
  {code: 'NC', label: 'No Charge'},
  {code: 'TE', label: 'Contract Price per Each'},
];
